// import {numberComplete}
import { numberComplete } from '@/utils'

export function levelTwo(data, legendData, title) {
  if (!data || !data.length) return null
  function fn(arr) {
    if (!arr) return
    const years = []
    const values = []
    const rates = []
    for (let index = 0; index < arr.length; index++) {
      const element = arr[index]
      years.push(element.year)
      values.push(numberComplete(element.value))
      rates.push(numberComplete(element.rate))
    }
    return { years, values, rates }
  }
  const { years, values, rates } = fn(data)
  return {
    title: {
      text: title,
      textStyle: {
        fontSize: 14
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    legend: {
      right: '10',
      data: legendData,
      itemWidth: 18,
      itemHeight: 12,
    },
    xAxis: [
      {
        type: 'category',
        data: years,
        axisPointer: {
          type: 'shadow'
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '单位：亿元',
        boundaryGap: true,
        alignTicks: true,
      },
      {
        type: 'value',
        boundaryGap: true,
        alignTicks: true,
        axisLabel: {
          formatter: '{value} %'
        }
      }
    ],
    series: [
      {
        name: legendData[0],
        type: 'bar',
        barWidth: '60%',
        // tooltip: {
        //   valueFormatter: function (value) {
        //     return value + ' ml';
        //   }
        // },
        data: values
      },
      {
        name: legendData[1],
        type: 'line',
        yAxisIndex: 1,
        tooltip: {
          valueFormatter: function (value) {
            return value + ' %';
          }
        },
        data: rates
      }
    ]
  }
}

export function companyCountChart(data) {
  if (!data) return null
  const { increaseStatList, hisStatList } = data
  if (!increaseStatList?.length || !hisStatList?.length) return null

  function fn(arr) {
    const years = []
    const values = []
    for (let index = 0; index < arr.length; index++) {
      const element = arr[index]
      years.push(element.year)
      values.push(element.value)
    }
    return { years, values }
  }
  const { years, values } = fn(increaseStatList)
  const { years: years2, values: values2 } = fn(hisStatList)

  return {
    title: {
      text: '企业数量趋势',
      textStyle: {
        fontSize: 14
      }
    },
    grid: {
      left: 80,
      right: 10,
      // containLabel: true
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    legend: {
      right: '10',
      itemWidth: 18,
      itemHeight: 12,
      data: ['存量企业', '增量企业']
    },
    xAxis: [
      {
        type: 'category',
        data: years,
        axisPointer: {
          type: 'shadow'
        },
        boundaryGap: true

      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '企业数量趋势',
        boundaryGap: true
      }
    ],
    series: [
      {
        name: '存量企业',
        type: 'bar',
        // tooltip: {
        //   valueFormatter: function (value) {
        //     return value + ' ml';
        //   }
        // },
        data: values2
      },
      {
        name: '增量企业',
        type: 'bar',
        // yAxisIndex: 1,
        // tooltip: {
        //   valueFormatter: function (value) {
        //     return value + ' °C';
        //   }
        // },
        data: values
      }
    ]
  }
}

export function smallPieChart(data, title) {
  if (!data || !data.length) return null

  return {
    title: {
      show: !!title,
      text: title,
      textStyle: {
        fontSize: 14
      }
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      type: 'scroll',
      orient: 'vertical',
      left: '60%',
      top: 'center',
      icon: 'circle',
      itemWidth: 10,
      itemHeight: 10,
      textStyle: {
        width: '80',
        overflow: 'truncate',
        fontSize: 12,
        lineHeight: 14
      }
    },
    series: [
      {
        name: title,
        type: 'pie',
        radius: ['32%', '50%'],
        center: ['35%', '50%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center'
        },
        labelLine: {
          show: false
        },
        data: data.map(e => ({ ...e, value: e.count }))
      }
    ]
  }
}

export function barChart(data, series) {
  if (!data || !data.length) return null

  function fn(arr) {
    const years = []
    const values = []
    for (let index = 0; index < arr.length; index++) {
      const element = arr[index]
      years.push(element.year)
      values.push(element.count)
    }
    return { years, values }
  }
  const { years, values } = fn(data)

  return {
    title: {
      text: '投融资次数趋势',
      textStyle: {
        fontSize: 14
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    grid: {
      left: 80,
      right: 10,
      // containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        data: years,
        axisTick: {
          alignWithLabel: true
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
      }
    ],
    series: [
      {
        name: '融资次数',
        type: 'bar',
        barWidth: '60%',
        data: values
      }
    ]
  };
}

export function pieChart(data) {
  if (!data) return null
  if (!data.detailList.length) return null

  return {
    title: {
      text: '投融资轮次分布情况',
      subtext: data.year,
      textStyle: {
        fontSize: 14
      }
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      left: '65%',
      top: 'center',
      icon: 'circle',
      itemWidth: 10,
      itemHeight: 10,
      textStyle: {
        width: 100,
        overflow: 'truncate',
        fontSize: 12
      }
    },
    series: [
      {
        name: '投融资轮次分布情况',
        type: 'pie',
        radius: ['40%', '60%'],
        center: ['40%', '50%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center'
        },
        // emphasis: {
        //   label: {
        //     show: true,
        //     fontSize: 40,
        //     fontWeight: 'bold'
        //   }
        // },
        labelLine: {
          show: false
        },
        data: data.detailList.map(e => ({ ...e, value: e.count }))
      }
    ]
  }
}

export function lineChart(data = {}) {

  if (!data) return null

  const { patent, trade_mark, copyright, software_copyright } = data
  const legendData = ['发明专利', '商标', '作品著作权', '软件著作权']
  const xAxisData = (patent || trade_mark || copyright || software_copyright || []).map(e => e.yearMonth)

  const seriesLists = [patent, trade_mark, copyright, software_copyright]

  const series = legendData.map((e, i) => ({
    name: e,
    type: 'line',
    data: seriesLists[i].map(e => e.count)
  }))
  return {
    title: {
      text: '知识产权分析',
      textStyle: {
        fontSize: 14
      }
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      right: '5%',
      data: legendData
    },
    grid: {
      left: 80,
      right: 10,
      // containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: xAxisData
    },
    yAxis: {
      type: 'value'
    },
    series
  }
}

export function treeMap(data) {
  if (!data || !data.length) return null
  const treeMapData = []

  function setData(e) {
    return { name: e.name, value: e.count, children: [] }
  }
  let seriesData2 = [{
    name: 1, value: 1, children: data.map(e => ({ ...e, value: e.count }))
  }]
  let seriesData = []

  data.reduce((p, v) => {
    // if(!test.length) test = p
    p.push({ name: v.name, value: v.count, children: [] })
    return p[0].children
  }, seriesData)


  console.log(seriesData);
  return {
    tooltip: {
      show: true
      // '{a} {b}'
    },
    color: [
      'rgba(22, 60, 125, 1)',
      'rgba(26, 71, 146, 1)',
      'rgba(32, 84, 174, 1)',
      'rgba(36, 96, 198, 1)',
      'rgba(48, 113, 226, 1)',
      'rgba(48, 113, 226, 0.8)',
      'rgba(48, 113, 226, 0.7)',
      'rgba(48, 113, 226, 0.6)',
      'rgba(48, 113, 226, 0.4)',
      'rgba(48, 113, 226, 0.3)'
    ],
    series: [
      {
        type: 'treemap',
        data: data.map(e => ({
          name: e.name,
          value: e.count
        })),
        // visualDimension: 1,
        // data: seriesData2,
        roam: false,
        nodeClick: false,
        breadcrumb: {
          show: false
        },
        width: '100%',
        height: '100%',
        // visibleMin: 300,
        // childrenVisibleMin: 300,
        // label: {
        //   fontSize: 10
        // }
      }
    ]
  }
}